"use client";

import { ArrowBackIcon, ArrowForwardIcon } from "@chakra-ui/icons";
import {
  Button,
  ButtonGroup,
  HStack,
  IconButton,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import React from "react";

interface PaginationProps {
  currentPage: number;
  totalPage: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPage,
  onPageChange,
}) => {
  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPage) {
      onPageChange(currentPage + 1);
    }
  };

  const isBreakpointVal = useBreakpointValue({ base: true, md: false });

  return (
    <Stack
      direction={{ base: "column", sm: "row" }}
      spacing={2}
      align="center"
      justify="center"
      mt={4}
      w="full"
    >
      <IconButton
        icon={<ArrowBackIcon />}
        aria-label="Previous"
        isDisabled={currentPage === 1}
        onClick={handlePrevPage}
        colorScheme="blue"
        size={isBreakpointVal ? "sm" : "md"}
        variant="outline"
      />

      {isBreakpointVal ? (
        <Text fontSize="sm" color="gray.600">
          Page {currentPage} of {totalPage}
        </Text>
      ) : (
        <ButtonGroup isAttached variant="outline" size="md">
          <Button isDisabled>{`Page ${currentPage} of ${totalPage}`}</Button>
        </ButtonGroup>
      )}

      <IconButton
        icon={<ArrowForwardIcon />}
        aria-label="Next"
        isDisabled={currentPage === totalPage}
        onClick={handleNextPage}
        colorScheme="blue"
        size={isBreakpointVal ? "sm" : "md"}
        variant="outline"
      />
    </Stack>
  );
};

export default Pagination;
